module.exports = __webpack_public_path__ + "img/Abstract-research.f4e3d42f.svg";